import { createSelector } from 'reselect';

// Config
import { getSessionIdSelector } from '@redux/reducers/bff/bffSelector';
import { getGooglePayConfiguration, isStripeCheckoutEnabledFeatureActive } from '@redux/reducers/config/configSelector';
import { getGooglePayCardPaymentMethod, getGooglePayStubsModalOpen } from '@redux/reducers/payment/paymentSelector';

const googlePayButtonState = createSelector(
  [
    getGooglePayCardPaymentMethod,
    getGooglePayStubsModalOpen,
    getGooglePayConfiguration,
    getSessionIdSelector,
    isStripeCheckoutEnabledFeatureActive,
  ],
  (
    googlePayCardPaymentMethod,
    googlePayStubsModalOpen,
    googlePayConfiguration,
    sessionId,
    stripeCheckoutFlowEnabled,
  ) => ({
    cardPaymentMethod: googlePayCardPaymentMethod,
    googlePayStubsModalOpen,
    googlePayConfiguration,
    sessionId,
    stripeCheckoutFlowEnabled,
  }),
);

export default googlePayButtonState;
